import React, { useState } from 'react';
import { InputV2 } from '../../atoms/v2/input/input-v2.atom';
import { useTranslation } from 'react-i18next';
import * as S from './coupon-section.molecule.style';
import { MdCreditCard } from 'react-icons/md';
import { Checkout } from '../../../common/types/checkout';
import { CouponSectionSkeleton } from '../cupom-skeleton/cupom-skeleton.molecule';

type Props = {
  checkout: Checkout;
  onApplyCoupon: (coupon: string) => void;
  discount: number;
  couponMessage?: string;
};

export const CouponSection: React.FC<Props> = ({
  onApplyCoupon,
  discount,
  couponMessage = 'Sucesso.',
  checkout,
}) => {
  const { t } = useTranslation();
  const [showCouponInput, setShowCouponInput] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

  const handleApplyCoupon = async () => {
    if (!couponCode) return;

    try {
      setIsApplyingCoupon(true);
      await onApplyCoupon(couponCode);
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  return (
    <S.CouponContainer>
      {!showCouponInput ? (
        <S.CouponToggle onClick={() => setShowCouponInput(true)}>
          <MdCreditCard size={12} />
          <span>{t('clickIfHaveDiscountCoupon')}</span>
        </S.CouponToggle>
      ) : isApplyingCoupon ? (
        <CouponSectionSkeleton />
      ) : (
        <S.CouponInputContainer>
          <S.CouponInputWrapper>
            <InputV2
              type="text"
              placeholder={t('discountCoupon')}
              value={couponCode}
              onChange={(e: any) => setCouponCode(e.target.value)}
              style={{ marginBottom: 0 }}
              disabled={isApplyingCoupon}
            />
            <S.ApplyCouponButton
              background={
                checkout?.checkoutConfig?.config?.checkoutData?.purchaseButton
                  ?.background
              }
              color={
                checkout?.checkoutConfig?.config?.checkoutData?.purchaseButton
                  ?.color
              }
              onClick={handleApplyCoupon}
              disabled={isApplyingCoupon}
            >
              {t('apply')}
            </S.ApplyCouponButton>
          </S.CouponInputWrapper>

          {couponMessage && (
            <S.CouponMessage success={discount > 0}>
              {couponMessage}
            </S.CouponMessage>
          )}
        </S.CouponInputContainer>
      )}
    </S.CouponContainer>
  );
};
